"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EVENT_ACTION;
(function (EVENT_ACTION) {
    EVENT_ACTION[EVENT_ACTION["UNKNOWN"] = 0] = "UNKNOWN";
    EVENT_ACTION[EVENT_ACTION["ERROR"] = 1] = "ERROR";
    EVENT_ACTION[EVENT_ACTION["EMIT"] = 2] = "EMIT";
    EVENT_ACTION[EVENT_ACTION["SUBSCRIBE"] = 3] = "SUBSCRIBE";
    EVENT_ACTION[EVENT_ACTION["UNSUBSCRIBE"] = 4] = "UNSUBSCRIBE";
    EVENT_ACTION[EVENT_ACTION["LISTEN"] = 5] = "LISTEN";
    EVENT_ACTION[EVENT_ACTION["UNLISTEN"] = 6] = "UNLISTEN";
    EVENT_ACTION[EVENT_ACTION["LISTEN_ACCEPT"] = 7] = "LISTEN_ACCEPT";
    EVENT_ACTION[EVENT_ACTION["LISTEN_REJECT"] = 8] = "LISTEN_REJECT";
    EVENT_ACTION[EVENT_ACTION["SUBSCRIPTION_HAS_PROVIDER"] = 9] = "SUBSCRIPTION_HAS_PROVIDER";
    EVENT_ACTION[EVENT_ACTION["SUBSCRIPTION_HAS_NO_PROVIDER"] = 10] = "SUBSCRIPTION_HAS_NO_PROVIDER";
    EVENT_ACTION[EVENT_ACTION["SUBSCRIPTION_FOR_PATTERN_FOUND"] = 11] = "SUBSCRIPTION_FOR_PATTERN_FOUND";
    EVENT_ACTION[EVENT_ACTION["SUBSCRIPTION_FOR_PATTERN_REMOVED"] = 12] = "SUBSCRIPTION_FOR_PATTERN_REMOVED";
    EVENT_ACTION[EVENT_ACTION["INVALID_LISTEN_REGEX"] = 100] = "INVALID_LISTEN_REGEX";
    EVENT_ACTION[EVENT_ACTION["LISTEN_RESPONSE_TIMEOUT"] = 101] = "LISTEN_RESPONSE_TIMEOUT";
    EVENT_ACTION[EVENT_ACTION["LISTEN_UNSUCCESSFUL"] = 102] = "LISTEN_UNSUCCESSFUL";
    EVENT_ACTION[EVENT_ACTION["MESSAGE_PERMISSION_ERROR"] = 103] = "MESSAGE_PERMISSION_ERROR";
    EVENT_ACTION[EVENT_ACTION["MESSAGE_DENIED"] = 104] = "MESSAGE_DENIED";
    EVENT_ACTION[EVENT_ACTION["INVALID_MESSAGE_DATA"] = 105] = "INVALID_MESSAGE_DATA";
    EVENT_ACTION[EVENT_ACTION["MULTIPLE_SUBSCRIPTIONS"] = 106] = "MULTIPLE_SUBSCRIPTIONS";
    EVENT_ACTION[EVENT_ACTION["NOT_SUBSCRIBED"] = 107] = "NOT_SUBSCRIBED";
})(EVENT_ACTION = exports.EVENT_ACTION || (exports.EVENT_ACTION = {}));
//# sourceMappingURL=event.js.map